/**
 * 应付费用模块
 */

const state = {
  providerList: [], // 应付主体
  providerData: [], // 运输主体
  outletsList: [], // 站点/网点
  operatorList: [], // 操作人
  isOperatorListLoading: false, // 操作人列表加载状态
  pmOperatorList: [], // pm_user
  feeTypeOption: [], // 费用类型
  providerChannelList: [] // 服务商
};

const mutations = {
  // 更新应付主体
  SET_PROVIDER_LIST(state, providerList) {
    state.providerList = providerList;
  },

  // 更新运输主体
  SET_PROVIDER_DATA(state, providerList) {
    state.providerData = providerList;
  },

  // 更新网点
  SET_OUTLETS_LIST(state, outletsList) {
    state.outletsList = outletsList;
  },

  // 更新操作人
  SET_OPERATOR_LIST(state, operatorList) {
    state.operatorList = operatorList;
  },

  // 更新操作人列表加载状态
  SET_OPERATOR_LIST_LOADING(state, isLoading) {
    state.isOperatorListLoading = isLoading;
  },

  // 更新费用类型
  SET_FEE_TYPE_OPTION(state, feeTypeOption) {
    state.feeTypeOption = feeTypeOption;
  },

  // 更新pm_user
  SET_PM_OPERATOR_LIST(state, pmOperatorList) {
    state.pmOperatorList = pmOperatorList;
  },

  // 更新服务商
  SET_PROVIDER_CHANNEL_LIST(state, providerChannelList) {
    state.providerChannelList = providerChannelList;
  }
};

const actions = {

};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters: {},
  modules: {}
};
